/**
 * @author Mustafa Omran <promustafaomran@hotmail.com>
 */
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import 'rxjs/add/observable/throw';
import { Handler } from './../handler';
import 'rxjs/add/operator/mergeMap';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Customer } from './../../models/customer.model';
import { environment } from './../../../../environments/environment';
import { OAuthService } from './../../../MartMax/services/oauth/oauth.service';
import { HttpModule, Http, Headers, Response, RequestOptions } from '@angular/http';

@Injectable()
export class AccountService {
    private baseUrl;

    constructor(
        private http: Http,
        private oauthService: OAuthService,
        private handler: Handler
    ) {
        this.baseUrl = environment.apiEndpoint;
    }

    public show(params: any): Observable<any> {
        let endpoint = 'customers/show';
        return this.oauthService.getAccessToken()
            .flatMap((data) => (this.aux(params, data, endpoint)))
            .catch(this.handler.render);
    }

    public aux(params: any, accessToken: String, endpoint: string): Observable<any> {
        let objHeaders = new Headers({
            'Content-Type': 'application/json',
            'Accept': 'application/vnd.rest.v1+json',
            'Authorization': `Bearer ${accessToken}`
        });
        let options = new RequestOptions({
            headers: objHeaders
        });
        let body = JSON.stringify(params);
        return this.http
            .post(this.baseUrl + endpoint, body, options)
            .map((response: Response) => (response.json().message));
    }
}



// WEBPACK FOOTER //
// /opt/build/repo/src/app/MartMax/services/customers/account.service.ts